module.exports = __webpack_public_path__ + "img/teacher2-3.fd5e8369.png";